'use strict';

var base = require('./base');
var quickView = require('base/product/quickView');
const { slickModalCarouselInit } = require('./initSlick');


/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($("#quickViewModal").length !== 0) {
      $("#quickViewModal").remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<button type="button" class="fa-close close" data-dismiss="modal">'
        + '</button>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer d-none"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}


/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    if(!selectedValueUrl) {
        return;
    }
    
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty().html(parsedHtml.body);
            // $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('.full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            maskColorSize(5);

            $('#quickViewModal').modal('show');
            if(data.wishlistMap.indexOf(data.product.id) != -1){
                handleWishlistMap(true,data.product.id);
            }else {
                handleWishlistMap(false,data.product.id);
            }
            $('body').trigger('quickview:ready');
        },
        error: function () {
        }
    }).done(function (){

        if($('#quickViewModal .product-quickview .size-button a.size-selector-box').length == 1){
            if(!$('#quickViewModal .product-quickview .size-button a.size-selector-box').hasClass('selected')) {
                $('#quickViewModal .product-quickview .size-button a.size-selector-box').trigger('click');
            } 
            setTimeout(() => {
                $('#quickViewModal .product-quickview .disabled-button-pdp').hide();
            }, 500);
        }

    });
    $.spinner().stop();
}

function handleWishlistMap(inlist,pid){
    if($('body').hasClass('modal-open')){
        var wishlistBtn = $('.product-quickview .secondary-button-wishlist-js');
    }else{
        var wishlistBtn = $('.product-detail .secondary-button-wishlist-js').first();
    }
    
    var qp = wishlistBtn[0].dataset.url.split('=');
        qp[1]=pid;
        wishlistBtn[0].dataset.url = qp.join('=');

    if(inlist){
        wishlistBtn.removeClass('wishlistTile').addClass('remove-from-wishlist');        
        wishlistBtn.find('.wishlist-tile-color').text('Wishlisted');
        wishlistBtn.find('.fa-stack-2x').removeClass('fa-heart-o').addClass('fa-heart');
        if(wishlistBtn.find('.fa-stack-2x').hasClass('fa-heart')){
            wishlistBtn.find('.fa-stack-2x').removeClass('d-none').addClass('fa-heart-o');
        }
    }else {
        wishlistBtn.removeClass('remove-from-wishlist').addClass('wishlistTile');
        wishlistBtn.find('.fa-stack-2x').removeClass('fa-heart').addClass('fa-heart-o');
        wishlistBtn.find('.wishlist-tile-color').text('Wishlist');
    }
}


function showQuickview() {
    $('body').on('click', '.quickview', function (e) {
        e.preventDefault();
        var selectedValueUrl = $(this).closest('a.quickview').attr('data-url');
        $(e.target).trigger('quickview:show');
        getModalHtmlElement();
        fillModalElement(selectedValueUrl);
    });

    $(document).on('click', '[data-attr="color"] button', function (e) {
        $('[data-attr="color"] button').removeClass('active');
        $(this).addClass('active');
        if( !$(this).closest('.product-quickview').length) {
            e.preventDefault();
            window.location.href = $(this).attr('href');
        }
    });
}

function focusQuickview() {
    $('body').on('shown.bs.modal', '#quickViewModal', function () {
        $('#quickViewModal .close').focus();
        $('.modal.show').css({'display':'flex','align-items':'center', 'justify-content':'center'});
        maskColorSize(5);
        setTimeout( function() {
            slickModalCarouselInit();
        }, 700); 
    });
}

function maskColorSize(length){
    var colorLength = $('.product-quickview .color-swatch-area .color-attribute').length;
    if (colorLength > length) {
        $('.product-quickview span.more-colors').removeClass('d-none');
        $('.product-quickview .color-swatch-area').find('.color-attribute').hide();
        $('.product-quickview .color-swatch-area').find('.color-attribute').slice(0, length).show();
    } else {
        $('.product-quickview span.more-colors').addClass('d-none');
        $('.product-quickview .color-swatch-area').find('.color-attribute').show();
    }

    // console.log('ajax complete for quickview');
    // setTimeout( function() {
    //     if($('.product-quickview .size-button a.size-selector-box').length == 1 && !$('.product-quickview .size-button a.size-selector-box').hasClass('selected')){
    //         $('.product-quickview .size-button a.size-selector-box').trigger('click');
    //     }
    // }, 500);
}


function sizeSelection() {
    $(document).on("click", ".size-selector-box", function (e) {
        e.preventDefault();
        let element = $(this);
        let wrapper = $(this).closest(".product-detail");
        let selectedValue = $(this).attr("data-attr-value");
    
        wrapper.find("option[data-attr-value]").removeAttr("selected");
        if (element.hasClass("active")) {
            element.removeClass("active");
            wrapper.find(".add-to-cart-global").attr("disabled", "disabled");
            wrapper.find('.buy-now-global').attr('disabled', 'disabled');
            if (wrapper.find(".update-cart-product-global-new").length) {
                wrapper.find(".update-cart-product-global-new").attr("disabled", "disabled");
            }
            wrapper.find("option[data-attr-value='" + selectedValue + "']").removeAttr("selected");
            wrapper.find('.disabled-button-pdp').show();
            wrapper.find('.size-not-selected-error').removeClass('d-none');
        } else {
            wrapper.find(".size-selector-box").removeClass("active");
            element.addClass("active");
            wrapper.find(".add-to-cart-global").removeAttr("disabled");
            if (wrapper.find(".update-cart-product-global-new").length) {
                wrapper.find(".update-cart-product-global-new").removeAttr("disabled");
            }
            wrapper.find("option[data-attr-value]").removeAttr("selected");
            wrapper.find("option[data-attr-value='" + selectedValue + "']").attr("selected", true);
            wrapper.find('.disabled-button-pdp').hide();
            wrapper.find('.buy-now-global').removeAttr('disabled');
            wrapper.find('.size-not-selected-error').addClass('d-none');
        }
    });

    $(document).on(
        'click',
        'div[data-role="controlgroup"] .size-button> a',

        function () {
            var btnvalue = $(this).attr('data-attr-value');
            var optionSelected = $(this).closest('.product-detail').find('.pdp-size-select option');
            optionSelected.each(function () {
                var attrvalue = $(this).attr('data-attr-value');
                if (
                    attrvalue.replace(/^\s+|\s+$/gm, '') ===
                    btnvalue.replace(/^\s+|\s+$/gm, '')
                ) {
                    $(this).closest('.product-detail').find('.pdp-size-select').val($(this).val()).trigger('change');
                    return false;
                }
                return true;
            });
        },
    );

    $(document).on('click', '.more-size', function () {
        $(this).closest('.size-button').find('a.size-selector-box').show();
        $('.more-size, .less-size').toggleClass('d-none');
    });

    $(document).on('click', '.less-size', function () {
        $(this).closest('.size-button').find('a.size-selector-box').hide();
        $(this).closest('.size-button').find('a.size-selector-box').slice(0, 5).show();
        $('.more-size, .less-size').toggleClass('d-none');
    });

    $(document).on('click', '.more-colors', function () {
        $(this).closest('.color-swatch-area').find('.color-attribute').show();
        $('.more-colors, .less-colors').toggleClass('d-none');
    });
    
    $(document).on('click', '.less-colors', function () {
        $(this).closest('.color-swatch-area').find('.color-attribute').hide();        
        $(this).closest('.color-swatch-area').find('.color-attribute').slice(0, 5).show();
        $('.more-colors, .less-colors').toggleClass('d-none');
    });
}
/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}


quickView.availability= base.availability;
quickView.addToCart= base.addToCart;

quickView.updateAttribute= function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {

        $('.product-quickview .size-selector-box').attr('data-product-id', response.data.product.id);

        if ($('.modal.show .product-quickview>.bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container)
                .find('.product-id').text(response.data.product.id);
        } else if ($('.set-items').length) {
            response.container.find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
            $('.modal.show .full-pdp-link')
                .attr('href', response.data.product.selectedProductUrl);
        }
    });
};

quickView.fillModalElement = fillModalElement;
quickView.getModalHtmlElement = getModalHtmlElement;
quickView.sizeSelection = sizeSelection;
quickView.parseHtml = parseHtml;
quickView.showQuickview = showQuickview;
quickView.focusQuickview = focusQuickview;

//module.exports = quickView;

module.exports = Object.assign(quickView);
